import { InspectionRowResponse } from "../../api-models/response/DataGridResponse";
import { formatValues } from "../../components/datatable/GridValuesFormatter";
import { DisplayValues, RowItemData } from "../../components/datatable/interfaces";
import dateService from "../date-service/DateService";
import { translationService } from "../translation/TranslationService";

export class Inspection implements RowItemData {
  id: number;
  private properties: DisplayValues;
  private gatheringDate: Date;
  private index: number;
  private isRelevant: boolean;

  static _constructorFromRowItem(inspectionRow: InspectionRowResponse, parentPagePath: string) {
    const object = new Inspection(inspectionRow);
    object.properties.SewerObject = inspectionRow.details.SewerObject;
    object.properties.SewerObject.path = 
      `${parentPagePath}/sewer-objects/section/${object.properties.SewerObject.id}`;
      object.properties.Inspection.path = `${object.properties.SewerObject.path}/inspections/${inspectionRow.id}`;
    return object;
  }

  constructor(inspectionRow: InspectionRowResponse) {
    this.properties = inspectionRow.details;
    this.id = inspectionRow.id;
    this.properties.Inspection.hasIssues = inspectionRow.hasIssues;
    this.properties.Inspection.maxIssueSeverity = inspectionRow.maxIssueSeverity;
    this.properties.Inspection.entityName = this.getEntityName();
    this.gatheringDate = inspectionRow.gatheringDate;
    this.index = inspectionRow.inspectionIndex;
    this.isRelevant = inspectionRow.isRelevant;
  }

  get displayValues() {
    this.properties = formatValues(this.properties);
    if (this.properties.OperatorScore) {
      this.properties.OperatorScore.toDisplay = this.scoreToPercentage(this.properties.OperatorScore.value);
    }
    if (this.properties.AIScore) {
      this.properties.AIScore.toDisplay = this.scoreToPercentage(this.properties.AIScore.value);
    }
    this.properties.Inspection.toDisplay = this.getInspectionDisplayName();
    this.properties.IsRelevant = {
      toDisplay: translationService.translate(
        `general.inspection.${this.isRelevant ? "relevant" : "outdated"}`
      ),
    };
    return this.properties;
  }

  private scoreToPercentage(score: number): string {
    return `${score.toString()}%`;
  }

  private getEntityName(): string {
    return "Inspection";
  }

  private getInspectionDisplayName(): string {
    return `${translationService.translate(`general.${this.getEntityName().toLowerCase()}`)} ${
      this.index
    } (${dateService.formatDate(this.gatheringDate)})`;
  }
}
